export default "__VITE_ASSET__Dj8711Kz__"